import type { ItemCreate, ItemPatch } from "@plannello/shared";
import { useSyncExternalStore } from "react";
import { getViews } from "./activeView";

export type CreateDefaults = Partial<ItemCreate>;

type State = { open: boolean; defaults: CreateDefaults; seq: number };
let state: State = { open: false, defaults: {}, seq: 0 };
const listeners = new Set<() => void>();
const emit = () => {
  for (const l of listeners) l();
};

/**
 * Opens quick create. Without explicit defaults it merges what the registered views suggest
 * (current product, the open item as parent, the focused column's status), topmost view last.
 */
export function openQuickCreate(defaults?: CreateDefaults) {
  const merged = defaults ?? Object.assign({}, ...getViews().map((v) => v.createDefaults?.() ?? {}));
  state = { open: true, defaults: merged, seq: state.seq + 1 };
  emit();
}

export function closeQuickCreate() {
  state = { ...state, open: false };
  emit();
}

export function useQuickCreateState(): State {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => state,
  );
}

/** The create fields a group's move-patch implies (create in this column / group). */
export function patchToCreate(patch: ItemPatch | null): CreateDefaults {
  if (!patch) return {};
  const out: CreateDefaults = {};
  if (patch.statusId) out.statusId = patch.statusId;
  if (patch.priority !== undefined) out.priority = patch.priority;
  if (patch.typeId) out.typeId = patch.typeId;
  if (patch.assignees?.add?.length) out.assigneeIds = patch.assignees.add;
  if (patch.labels?.add?.length) out.labelIds = patch.labels.add;
  return out;
}
